import React from 'react'
import TablePage from '../../../../../components/pages/TablePage'
import moment from 'moment'
export default () => {
    const columns=[
        {
            selector:(row)=>row?.name,
            name:"Name",
            id:'name',
            compact:true
        },
        {
            selector:(row)=>(row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY HH:mm')) || '-',
            name:"CreatedAt",
            id:'created_at'
        },
        {
            selector:(row)=>row?.createdBy?.username || '-',
            name:"CreatedBy",
            id:'created_by'
        },
    ]
    return (
        <TablePage
            title={"Master Kanwil"}
            url="api/v1/kanwil"
            actionPosition={'first'}
            createPath="/master/kanwil/create"
            editPath={"/master/kanwil/edit"}
            columns={columns}            
        />
    )
}